export function formatDate(date) {
    return (date.getMonth() + 1) + '/' + date.getDate();
}

